import { LightningElement, api, wire } from "lwc";
import { c as classNames } from "tds/chunk_index";
import { LabelsAdapter } from "common/labelsAdapter";
import { AnimationAdapter } from "common/animationAdapter";

var data$9 = { loading: "Ladevorgang läuft" };
data$9.loading;

var data$8 = { loading: "Loading" };
data$8.loading;

var data$7 = { loading: "Cargando" };
data$7.loading;

var data$6 = { loading: "Cargando" };
data$6.loading;

var data$5 = { loading: "Chargement" };
data$5.loading;

var data$4 = { loading: "Caricamento in corso" };
data$4.loading;

var data$3 = { loading: "読み込んでいます" };
data$3.loading;

var data$2 = { loading: "로딩 중" };
data$2.loading;

var data$1 = { loading: "Carregando" };
data$1.loading;

var data = { loading: "正在加载" };
data.loading;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

const DEFAULT_SIZE = "medium";
const DEFAULT_VARIANT = "base";
class spinner extends LightningElement {
  @api size = DEFAULT_SIZE;
  @api variant = DEFAULT_VARIANT;
  get className() {
    return classNames(
      `spinner spinner--${this.size} spinner--${this.variant}`,
      {
        animated: this.animation.enabled,
      }
    );
  }
  @wire(LabelsAdapter, {
    locales,
  })
  labels = null;
  @wire(AnimationAdapter)
  animation = null;
}

export default spinner;
